import * as React from 'react'
import { DVString } from 'DVWebNodeUtils'
import { Text as DVStringProcessor, IconType, Icon, BaseComponentProps } from 'DVWebNodeUI'
import * as styles from './Infobox.module.scss';
import * as cn from 'classnames'

export interface InfoboxProps extends BaseComponentProps {
    message: DVString
    type?: string
}

export const Infobox = (props: InfoboxProps) => (
    <div className={cn(styles.Infobox, props.className)} >
        <Icon use={IconType.ENTITLED_TICK} />
        <DVStringProcessor string={props.message} />
    </div>
)